module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('modal-register-agreement', {
    attrs: {
      "show": _vm.showModal
    },
    on: {
      "close": function($event) {
        _vm.showModal = false
      },
      "update:show": function($event) {
        _vm.showModal = $event
      }
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "bar bar-nav"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("注册协议")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-19467000","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/User/MyAgreement/MyAgreement.vue
// module id = 1553
// module chunks = 8